import ObservableModel from "util/ObservableModel";
export default ObservableModel.extend({}, function () {});
